// Module
var code = "You should return to the location you chose as home, press ‘I’m there’ when you are. ";
// Exports
module.exports = code;